import { Vector3 } from "three";
import {
  DefensivePlayMode,
  DefensivePlayState,
  LocationOfInterest,
  PositionOfInterest,
} from "../../managers/playstate";
import { DefensiveActionControllerStrategy } from "./action";
import { CameraLandmark, CameraLandmarkLookup } from "../controller";

/**
 * Pitcher auto camera
 */
export class PitcherControllerStrategy extends DefensiveActionControllerStrategy {
  getHomePosition(): Vector3 {
    const currentPlay = this.registered?.contextRef.gameState.getCurrentPlay();
    if (currentPlay?.matchup?.pitchHand.code == "L") {
      return CameraLandmarkLookup[CameraLandmark.MOUND_LEFT];
    } else {
      return CameraLandmarkLookup[CameraLandmark.MOUND_RIGHT];
    }
  }
  getPrimaryPointOfInterest(
    playState: DefensivePlayState
  ): PositionOfInterest | undefined {
    if (
      this.registered &&
      (playState.mode === DefensivePlayMode.BEGIN ||
        playState.mode === DefensivePlayMode.PITCHING)
    ) {
      return new LocationOfInterest(
        this.registered.contextRef,
        CameraLandmark.PITCHER_POV
      );
    } else {
      return super.getPrimaryPointOfInterest(playState);
    }
  }
  getZoomToValue(playState: DefensivePlayState): number {
    if (
      this.registered &&
      (playState.mode === DefensivePlayMode.BEGIN ||
        playState.mode === DefensivePlayMode.PITCHING)
    ) {
      return 3.5;
    } else {
      return super.getZoomToValue(playState);
    }
  }
}
